import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Un avocat est-il indispensable en cas d’alcool au volant?"
            description="Arrêté et accusé d’alcool au volant? Découvrez pourquoi être représenté par un avocat dès le début peut faire toute la différence sur le verdict final!"
            fr={undefined}
            lawType="criminal"
            specialtyText="pour alcool au volant">
            <p>
                Bien que vous ayez le droit de vous représenter seul lors de
                procédures juridiques, la présence d’un avocat peut faire la
                différence entre un acquittement et une déclaration de
                culpabilité.{' '}
            </p>
            <p>
                Si vous êtes accusé d’alcool au volant, il ne s’agit pas
                simplement d’un constat d’infraction, mais bien d’une accusation
                criminelle pouvant entraîner de{' '}
                <Link to="https://avocatsalcoolauvolant.ca/consequences-alcool-volant/">
                    lourdes conséquences
                </Link>{' '}
                : casier judiciaire, suspension ou perte du permis de conduire,
                amendes élevées, voire peine d’emprisonnement.
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Un avocat fait une réelle différence en cas d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Grâce à Avocats Alcool au Volant, voyez à quoi sert un
                    avocat lors d’accusation d’alcool au volant!
                </strong>
            </p>
            <h2>
                <strong>Suis-je obligé d’avoir un avocat ?</strong>
            </h2>
            <p>
                Non, à moins de circonstances exceptionnelles, toute personne a
                le droit de se représenter seule lors de procédures judiciaires.{' '}
            </p>
            <p>
                Il n’est pas obligatoire d’être assisté par un avocat, même
                lorsqu’on fait face à des accusations criminelles. Lorsque vous
                êtes mis en état d’arrestation, vous avez le{' '}
                <strong>droit à un avocat</strong>. Il ne s’agit pas d’une
                obligation et vous pouvez refuser.{' '}
            </p>
            <p>
                Cela dit, dans le cas d’une arrestation pour conduite avec les
                facultés affaiblies par l’alcool, faire appel à un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-conduite-facultes-affaiblies/">
                    avocat spécialisé en droit criminel
                </Link>{' '}
                peut véritablement influencer l’issue du dossier!
            </p>
            <p>
                Dès le début, l’avocat fournit des conseils juridiques
                essentiels, veille au respect des droits de la personne accusée
                et la représente devant le tribunal. Son expertise peut ainsi
                mener à un acquittement!
            </p>
            <h2>
                <strong>
                    Un avocat apporte des conseils dès l’arrestation
                </strong>
            </h2>
            <p>
                Dès l’arrestation pour conduite avec les facultés affaiblies par
                l’alcool, les policiers ont l’obligation d'informer la personne
                de son droit constitutionnel de consulter un avocat.
            </p>
            <p>
                Ce droit, garanti par la Charte canadienne, est fondamental, car
                les conseils d’un avocat à ce stade peuvent avoir une influence
                déterminante sur la suite des événements.
            </p>
            <p>
                L’avocat va s’assurer que la personne connaisse ses droits,
                notamment le droit de garder le silence afin d’éviter de faire
                des déclarations qui pourraient être retenues contre elle.
                D’ailleurs, l’avocat joue un rôle stratégique en conseillant la
                personne sur l’attitude à adopter face aux policiers.
            </p>
            <p>
                Par exemple, un avocat va recommander au conducteur de
                collaborer lors de la demande d’un échantillon d’haleine, car{' '}
                <Link to="https://avocatsalcoolauvolant.ca/refus-souffler-alcootest/">
                    refuser de se soumettre à un alcootest
                </Link>{' '}
                constitue une infraction criminelle passible de sanctions aussi
                sévères que celles liées à la conduite avec les facultés
                affaiblies.
            </p>
            <p>
                L’avocat guide la personne sur la démarche à suivre, sur ce
                qu’elle peut dire ou ne peut pas dire, faire ou ne pas faire.
                Cette intervention rapide permet de protéger efficacement les
                droits de l’accusé.
            </p>
            <h2>
                <strong>
                    Un avocat peut présenter des arguments ou des moyens de
                    défense afin de soulever un doute raisonnable
                </strong>
            </h2>
            <p>
                Être accusé de conduite avec les facultés affaiblies ne signifie
                pas être reconnu coupable. En droit criminel, la poursuite doit
                démontrer hors de tout doute raisonnable que l’infraction a bel
                et bien été commise.
            </p>
            <p>
                <strong>Le rôle de l’avocat est donc central : </strong>en
                présentant des arguments et moyens de défense pertinents, il
                peut soulever un doute raisonnable et ainsi obtenir un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/acquittement-alcool-volant-erreur-police/">
                    acquittement
                </Link>
                !
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Acquittement pour alcool au volant avec un avocat!"
                    alt=""
                />
            </p>
            <p>
                L’
                <strong>
                    infraction de conduite avec les facultés affaiblies
                </strong>{' '}
                peut être constituée de deux façons :
            </p>
            <ul>
                <li>
                    Lorsqu’une personne conduit un véhicule avec des facultés
                    affaiblies par l’alcool, une drogue ou les deux.
                </li>
                <li>
                    Lorsqu’une personne présente, dans les deux heures suivant
                    la conduite, un taux d’alcool égal ou supérieur à 80 mg par
                    100 ml.
                </li>
            </ul>
            <p>
                L’avocat peut intervenir de différentes manières selon la base
                de l’accusation et les circonstances de l’arrestation pour
                soulever des arguments ou moyens de défense
            </p>
            <h3>
                <strong>
                    1) Contester les signes d’affaiblissement des capacités de
                    conduire
                </strong>
            </h3>
            <p>
                Lorsqu’une personne est accusée de conduite avec les facultés
                affaiblies, la preuve d’un affaiblissement des capacités repose
                sur des éléments circonstanciels comme un comportement agité,
                une odeur d’alcool, une démarche instable ou des troubles de
                coordination.
            </p>
            <p>
                Ces indices isolés{' '}
                <strong>ne suffisent pas à prouver l’affaiblissement, </strong>
                car les tribunaux exigent une appréciation globale du contexte.
            </p>
            <p>
                Un avocat peut alors intervenir en soutenant que ces
                comportements s’expliquent autrement, par exemple :
            </p>
            <ul>
                <li>Le stress</li>
                <li>La fatigue</li>
                <li>Un état émotionnel</li>
                <li>Une situation familiale</li>
                <li>Un problème de santé</li>
            </ul>
            <p>
                L’avocat peut contester la crédibilité ou la précision des
                témoignages policiers. En démontrant que les signes
                d’affaiblissement des capacités de conduite ne sont pas liés à
                la consommation d’alcool, il peut soulever un doute raisonnable
                qui contraint le juge à acquitter l’accusé.
            </p>
            <h3>
                <strong>
                    2) Contester la validité des résultats d’alcoolémie
                </strong>
            </h3>
            <p>
                L’analyse de l’échantillon doit respecter des règles strictes.
                Certaines conditions doivent être remplies pour que le taux
                d’alcool bénéficie d’une présomption d’exactitude.
            </p>
            <p>
                L’avocat de la défense vérifiera minutieusement si toutes les
                exigences techniques ont été respectées, notamment :
            </p>
            <ul>
                <li>
                    L’appareil a été manipulé par un{' '}
                    <strong>technicien qualifié,</strong> dont la formation et
                    les certifications étaient à jour au moment de l’analyse.
                </li>
                <li>
                    Avant chaque prélèvement,{' '}
                    <strong>un test à blanc a été réalisé</strong> pour vérifier
                    l’absence d’alcool résiduel dans l’éthylomètre, avec un
                    seuil maximal fixé à 10 mg d’alcool par 100 ml de sang.
                </li>
                <li>
                    Un <strong>test d’étalonnage a confirmé</strong> que
                    l’appareil présentait un écart maximal de 10 % par rapport à
                    une valeur cible certifiée par un analyste.
                </li>
                <li>
                    Les prélèvements ont été effectués avec un{' '}
                    <strong>intervalle minimum de 15 minutes </strong>entre
                    chaque échantillon.
                </li>
                <li>
                    Les résultats, arrondis à la dizaine inférieure, ne
                    présentaient pas de{' '}
                    <strong>
                        différence supérieure à 20 mg d’alcool par 100 ml{' '}
                    </strong>
                    de sang entre les deux mesures.
                </li>
            </ul>
            <p>
                Si une de ces conditions n’est pas respectée, la présomption
                d’exactitude tombe. L’avocat peut alors{' '}
                <strong>remettre en cause la validité des résultats</strong>, ce
                qui crée un doute raisonnable sur le véritable taux d’alcoolémie
                de l’accusé. Le travail de l’avocat, qui consiste à vérifier si
                toutes les conditions ont été respectées, peut faire la
                différence entre une condamnation et un acquittement!
            </p>
            <h3>
                <strong>
                    3) Invoquer une violation des droits constitutionnels
                </strong>
            </h3>
            <p>
                Un autre volet central du travail de l’avocat concerne le
                respect des droits constitutionnels de l’accusé. La Charte
                canadienne plusieurs droits, notamment:
            </p>
            <ul>
                <li>le droit à l’assistance d’un avocat, </li>
                <li>
                    le droit d’être informé des motifs de son arrestation, et{' '}
                </li>
                <li>le droit d’être jugé dans un délai raisonnable.</li>
            </ul>
            <p>
                Si l’un de ces droits est violé, l’avocat peut déposer une{' '}
                <strong>requête en exclusion de la preuve</strong>, ce qui rend
                difficile l’établissement de la culpabilité du conducteur et
                peut conduire à un acquittement. Dans les cas les plus graves,
                l’avocat peut demander l’arrêt des procédures judiciaires, ce
                qui équivaut à un acquittement.
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Moyens de défense pour alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Voici les violations que l’avocat peut identifier et pour
                lesquelles il peut déposer des requêtes, susceptibles de mener à
                l’acquittement de l’accusé.
            </p>
            <table>
                <tr>
                    <td>
                        <p>Violations</p>
                    </td>
                    <td>
                        <p>Explication</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Droit de consulter un avocat</p>
                    </td>
                    <td>
                        <p>
                            La Charte garantit à toute personne arrêtée le droit
                            de consulter un avocat sans délai. L’avocat vérifie
                            que ce droit a été clairement communiqué et
                            respecté.
                        </p>
                        <p>
                            En cas de non-respect, l’avocat peut demander
                            l’exclusion des preuves obtenues entre le moment de
                            l’arrestation et celui où l’accusé a pu consulter un
                            avocat.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Droit de connaître les motifs de l’arrestation</p>
                    </td>
                    <td>
                        <p>
                            La Charte garantit le droit d’être informé
                            clairement des motifs d’arrestation.
                        </p>
                        <p>
                            Si les policiers ne précisent pas que l’accusé est
                            arrêté pour conduite avec facultés affaiblies ou
                            utilisent des termes vagues, l’avocat peut demander
                            l’exclusion des preuves recueillies alors que
                            l’accusé ignorait les motifs de son arrestation.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Droit être jugé dans un délai raisonnable</p>
                    </td>
                    <td>
                        <p>
                            La Charte garantit un procès dans un délai
                            raisonnable. Si ce délai (18 mois en Cour du Québec,
                            30 en Cour supérieure) est dépassé sans raison
                            valable, l’avocat peut demander l’arrêt des
                            procédures.
                        </p>
                        <p>
                            L’avocat doit démontrer que les retards ne sont pas
                            imputables à l’accusé et qu’ils portent atteinte à
                            son droit à un procès équitable. Si la Cour accepte
                            cet argument, elle ordonne l’arrêt des procédures,
                            ce qui équivaut à un acquittement.
                        </p>
                    </td>
                </tr>
            </table>
            <h2>
                <strong>
                    Vous êtes accusé de conduite avec les facultés affaiblies
                    par l’alcool? Consultez un avocat spécialisé en droit
                    criminel!
                </strong>
            </h2>
            <p>
                Si vous avez été arrêté pour conduite avec les facultés
                affaiblies par l’alcool et faites face à des accusations
                criminelles, il est plus que recommandé de consulter un avocat
                spécialisé en droit criminel. Grâce à son expérience, cet avocat
                saura vous offrir le soutien juridique nécessaire pour protéger
                vos droits.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Avocat pour être acquitté d’alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire simple et gratuit, vous serez en
                    mesure de trouver rapidement un avocat spécialisé en droit
                    criminel !
                </strong>
            </p>
            <p>
                <strong>
                    Suite à votre demande, nous vous mettrons rapidement en
                    contact avec un avocat criminaliste près de chez vous. Ce
                    processus ne nécessite aucun engagement de votre part !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "avocat-indispensable-alcool-volant/alcool-alcool-volant-importance.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "avocat-indispensable-alcool-volant/acquittement-alcool-volant-avocat.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "avocat-indispensable-alcool-volant/moyens-defense-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "avocat-indispensable-alcool-volant/avocat-acquitter-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
